module.exports = __webpack_public_path__ + "img/22200.e3372b33.jpg";